import React from "react";
import "./HeaderStyle.css";

const HeaderOS1 = ({tipo}) => {

    let imgScr = (tipo=="OS"?"./header-setia-os-logo.png":"./header-setia-sin-logo.png")

    return (<>
        <div className="row">
            <div className="col-3 imageLeftContainer">
            {(tipo=="OS" || tipo=="OSSIN")? <img  className="oneImage1Style" src="./header-setia-os-logo.png"/>:""}

            </div>
            
            <div className="col-6 oneImage1Container title1">
                SINDICATO DE EMPLEADOS TEXTILES DE LA INDUSTRIA Y AFINES
            </div>
            <div className="col-3 imageRightContainer">
                {(tipo=="SIN" || tipo=="OSSIN")?<img  className="oneImage1Style" src="./header-setia-sin-logo.png"/>:""}

            </div>
     
        </div>


<hr style={{height:"1px",border:"none",color:"#333",backgroundColor:"#333"}}></hr>
        </>
    );

}

export default HeaderOS1;